import React, { useId } from 'react';
import { Stack, Badge } from '@moda/om';
import { SizeInventoryFragment } from '../../generated/types';
import { SizeGuideLink, showSizeGuide } from '../SizeGuide';
import { SizeSelectorList } from './SizeSelectorList';
import './MobileSelectSizeView.scss';

type Props = {
  fitRecommendation?: string | null;
  sizes: SizeInventoryFragment[];
  sizeEquivalents: string[][];
  disableSizeMapping: boolean;
  selectedSize: SizeInventoryFragment | null;
  onSelect: (size: SizeInventoryFragment) => void;
  onClose?: () => void;
};

export const MobileSelectSizeView: React.FC<Props> = ({
  fitRecommendation,
  sizes,
  sizeEquivalents,
  disableSizeMapping,
  selectedSize,
  onSelect,
  onClose
}) => {
  const listboxId = useId();

  return (
    <Stack space={4}>
      {fitRecommendation && <Badge theme="noise">{fitRecommendation}</Badge>}
      <SizeSelectorList
        id={listboxId}
        sizes={sizes}
        sizeEquivalents={sizeEquivalents}
        disableSizeMapping={disableSizeMapping}
        selectedSize={selectedSize}
        onSelect={onSelect}
        onClose={onClose ?? (() => {})}
      />
      {showSizeGuide({ sizeEquivalents, disableSizeMapping }) && (
        <div className="MobileSelectSizeView__footer">
          <SizeGuideLink
            sizes={sizes}
            sizeEquivalents={sizeEquivalents}
            disableSizeMapping={disableSizeMapping}
            fitRecommendation={fitRecommendation}
          />
        </div>
      )}
    </Stack>
  );
};
